import { browserTracingIntegration } from '@sentry/vue';
import { sentryBaseModel } from 'shared';
import type { App } from 'vue';
import type { Router } from 'vue-router';
import type { SeverityLevel } from '@sentry/vue';

import { appConfig } from '@/shared/config';

type LogErrorPayload = {
  error: Error;
  description: string;
  level?: SeverityLevel;
  extra?: Record<string, unknown>;
};

const sentryInstance = sentryBaseModel.getSentryInstance();

const initSentry = (app: App, router: Router) => {
  sentryBaseModel.initSentry({
    app,
    dsn: appConfig.SENTRY_DSN,
    integrations: [browserTracingIntegration({ router })],
  });
};

/**
 * `captureException`'s second argument is a `CaptureContext`, which only reads
 * known keys (`extra`, `tags`, `contexts`, `level`, `user`, `fingerprint`).
 * Passing the extras bag flat matched none of them, so every field was silently
 * dropped and reports arrived in Sentry with no diagnostic context at all — it
 * has to be nested under `extra`.
 */
const logBaseError = ({
  error,
  description,
  extra,
  level = sentryInstance.level.FATAL,
}: LogErrorPayload) => {
  sentryInstance.withScope(scope => {
    scope.setLevel(level);
    sentryInstance.captureException(
      sentryInstance.getReadableError(description, error),
      { extra },
    );
  });
};

export const sentryModel = {
  initSentry,
  logBaseError,
  ...sentryInstance,
};
